const CUSTOMER_EXPERIENCE_PREFIX = "customer_experience_v1";

export const createCustomerExperienceKey = (businessSubDomain) =>
  `${CUSTOMER_EXPERIENCE_PREFIX}:${String(businessSubDomain || "")
    .trim()
    .toLowerCase()}`;

export const loadCustomerExperience = (businessSubDomain) => {
  if (!businessSubDomain) return null;

  try {
    const raw = localStorage.getItem(
      createCustomerExperienceKey(businessSubDomain)
    );
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (error) {
    console.error("Customer experience verisi okunamadı:", error);
    return null;
  }
};

export const saveCustomerExperience = (businessSubDomain, value) => {
  if (!businessSubDomain) return;

  try {
    localStorage.setItem(
      createCustomerExperienceKey(businessSubDomain),
      JSON.stringify(value)
    );
  } catch (error) {
    console.error("Customer experience verisi kaydedilemedi:", error);
  }
};
